import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
        loggedIn: false,
        data: null,
    },
    company:{
        data: null
    },
    data:{
        data: null
    }
  },
  getters: {
    user(state){
      return state.user
    },
    company(state){
        return state.company
    },
    data(state){
        return state.data
    },
    // baseUrl(state){
    //   return state.baseUrl
    // }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_COMPANY(state, data) {
      state.company.data = data;
    },
    SET_COMPANY_LOGO(state, data) {
      state.company.data.logoUrl = data;
    },
    SET_DATA(state, value){
      state.data.data  = value
    },
    // SET_BASE_URL(state, baseURL){
    //   state.baseUrl = baseURL;
    // }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", true);
      commit("SET_USER", user)
    },
    userLogoff({commit}) {
        commit("SET_LOGGED_IN", true);
        commit("SET_USER", null)
    },
    fetchCompany({ commit }, company) {
        commit("SET_COMPANY",company);
    },    
    fetchCompanyLogo({ commit }, logoUrl) {
        commit("SET_COMPANY_LOGO",logoUrl);
    },    
    fetchData({ commit }, data){
        commit("SET_DATA", data)
    },
    // fetchBaseUrl({ commit }, baseURL){
    //     commit("SET_BASE_URL", baseURL )
    // }
  }  
});
